import {VehicleFinancingBalloonPayment} from '@dms/api/sales';

/**
 * Balloon payment bracket the vehicle panel falls back to when neither the template nor its cells
 * name one. The template editor preselects `INITIAL_BALLOON_BRACKET` instead.
 */
export const DEFAULT_BALLOON_PAYMENT: VehicleFinancingBalloonPayment = 30;
